import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { getRecords } from "../../../services/api.service";
import { exportPageData } from "./InstallationFile";

const breadcrumbItems = [];

const InstallationList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [dataForExport, setDataForExport] = useState([]);

  useEffect(() => {
    getData();
  }, [searchKeyword, page, pageSize]);
  useEffect(() => {
    const handleExportData = async () => {
      const project_id = JSON.parse(localStorage.getItem("projectID"));
      try {
        const exportPageData = {
          modelName: "installation_commissioning_list_masters",
          relations: [
            {
              module: "company_masters",
              moduleAs: "customer",
            },
          ],
          whereCondition: {
            type: 1,
            project_id: project_id,
          },
          pagination: { page: 1, pageSize: 10000 },
        };
        const responseData = await getRecords(exportPageData, "/getRecords");
        console.log("responseData", responseData.data);
        setDataForExport(responseData.data);
      } catch (error) {
        console.error("Error fetching records:", error);
      }
    };

    handleExportData();
  }, []);
  const exportData = dataForExport?.map((item, index) => ({
    "Sr. No": index + 1,
    "FORM NAME": item?.form_name || "N/A",
    "COMPANY NAME": item.customer?.company_name || "N/A",
    "FORM NAME": item?.form_name || "N/A",

    STATUS:
      item?.is_active === false || item?.is_active === 0
        ? "In-active"
        : "Active",
  }));
  const getData = async () => {
    const project_id = JSON.parse(localStorage.getItem("projectID"));

    try {
      const payload = {
        modelName: "installation_commissioning_list_masters",
        relations: [
          {
            module: "company_masters",
            moduleAs: "customer",
          },
        ],
        whereCondition: {
          type: 1,
          project_id: project_id,
        },
        search: {
          field_name: ["form_name", "po_number"],
          searchKeyword: searchKeyword,
        },
        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },
      };

      const responseData = await getRecords(payload, "/getRecords");

      // Assign an `index` property starting from 1
      responseData.data.forEach((element, index) => {
        element.index = index + 1;
      });
      setTotalCount(responseData.count);

      const sortedData = responseData.data.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickAdd = () => {
    navigate("/installation-create");
  };

  const handleEditClick = (id) => {
    navigate(`/installation-create/${id}`);
  };
  const handleViewClick = (id) => {
    navigate(`/installation-view/${id}`);
  };
  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };

  const columns = useMemo(
    () => [
      {
        Header: "SR.NO.",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },
      {
        Header: "CUSTOMER NAME",
        accessor: (row) =>
          row.customer && row.customer ? row.customer.company_name : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "FORM NAME",
        accessor: (row) =>
          row.form_name && row.form_name ? row.form_name : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "200px" }}>{value}</div>,
      },
      {
        Header: "PO NUMBER",
        accessor: (row) =>
          row.po_number && row.po_number ? row.po_number : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "200px" }}>{value}</div>,
      },
      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === "Active" || value === false || value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px", display: "flex" }}>
            <div
              onClick={() => {
                handleEditClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-pencil font-size-18"></i>
              </Link>
            </div>
            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize],
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb
              title="Installation List"
              breadcrumbItems={breadcrumbItems}
            />
            <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleClickAdd}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create Installation
            </Button>
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
                exportData={exportData}
                exportFileName="installationData.xlsx"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InstallationList;
